// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606160823/js/" + chunkId + "." + {"44":"90fe5f97","225":"a6ab301b","481":"cb423996","486":"c3b6f7fc","770":"823a52b2"}[chunkId] + ".0.7119377291662617.chunk.js";
};